// React & Libraries
import React, { Fragment } from 'react';

// Ant Design
import {
  Tabs
} from 'antd';

// Constants & Helpers
import { QUANTITY } from '@Apis/constants';

// Local components
import SOLines from '../SOLines';
import UnFulfilledLines from '../UnFulfilledLines';
import FulfilledLines from '../FulfilledLines';
import ReturnFulfilledLines from '../ReturnFulfilledLines';
import RefundLines from '../RefundLines';
import { handleDrawerStateHelper, getTotalQuantity } from '../helper';

const { TabPane } = Tabs;

function ViewSOLeftSectionTables({
  props, state, updateState, quickUpdateDisable, hasSoEditAccess, quantityPrecision
}) {

  const {
    user, getSOById, selectedSO, getActivityLog,
  } = props;

  const {
    soMapping, currentTenantId, currentOrderId, currentTab, visibleColumns, cfSalesOrderLine, salesOrderType, documentUINames, isEstimate
  } = state;

  const handleDrawerState = (type, value1, value2, value3, value4) => (
    handleDrawerStateHelper({ type, value1, value2, value3, value4, props, state, updateState })
  );

  return (
    <Fragment>
      <Tabs
        activeKey={currentTab}
        onChange={(key) => {
          updateState({ currentTab: key });
        }}
        mode="horizontal"
        type="card"
      >
        {/* {<TabPane tab={`${isEstimate ? 'Estimate' : 'Sales Order'} Lines`} key="/sales-order-lines" />} */}
        {<TabPane tab={`${documentUINames.uiName} Lines`} key="/sales-order-lines" />}
        {selectedSO?.shopify_fulfillments && <TabPane tab="Shopify Fulfilments" key="/shopify-fulfilments" />}
        {selectedSO?.shopify_fulfillments && <TabPane tab="Shopify Returns" key="/shopify-returns" />}
        {selectedSO?.shopify_fulfillments && <TabPane tab="Shopify Refunds" key="/shopify-refunds" />}
      </Tabs>
      {/* Sale Order Lines */}
      {currentTab === '/sales-order-lines' && (
        <div>
          <SOLines
            soLines={selectedSO?.sales_order_lines?.map((item) => ({
              ...item,
              lineCustomFields: item?.so_line_custom_fields,
              product_category_info: item?.product_sku_info?.product_category_info,
            })) || []}
            selectedSO={selectedSO}
            callback={() => {
              const payload = {
                orgId: user?.tenant_info?.org_id,
                tenantId: currentTenantId,
                soId: currentOrderId,
                orderType: salesOrderType,
              };
              getSOById(payload);
            }}
            cfSalesOrderLine={cfSalesOrderLine}
            visibleColumns={visibleColumns}
            setVisibleColumns={(data) => updateState({ visibleColumns: data })}
            callbackState={(val) => {
              updateState({ isUserReadyForPrefillData: val });
            }}
            isEditable={quickUpdateDisable && hasSoEditAccess}
            activityLogUpdater={() => getActivityLog(selectedSO.order_id, salesOrderType?.toLowerCase(), 1, 10)}
            selectedOrderLine={(lineData) => updateState({ selectedOrderLine: lineData })}
            setUpdateReserveDrawerOpen={() => updateState({ showUpdateReservationDrawer: true })}
            isEstimate={isEstimate}
            isAMC={selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT'}
          />
          {(user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.show_total_quantity || user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.settings?.show_total_quantity) && (selectedSO?.order_type === 'SALES_ORDER' || selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT') && (
            <div className="total-quantity">
              <span className="total-quantity__label">Total Quantity :</span>
              <span className="total-quantity__value">
                {(selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ?
                  (user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.settings?.calculate_total_quantity_with_parent_quantity_for_bundle_products)
                  : (user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.calculate_total_quantity_with_parent_quantity_for_bundle_products))
                  ? getTotalQuantity(selectedSO?.sales_order_lines)
                  : QUANTITY(selectedSO?.sales_order_lines?.reduce((total, item) => {
                    // If the item is a bundle, ignore its own quantity and only sum the bundle products' quantities
                    if (item.is_bundle && item.bundle_products?.length) {
                      const bundleTotal = item.bundle_products.reduce((bundleTotal, bundleItem) => {
                        return bundleTotal + (bundleItem.quantity || 0); // Sum the quantity of each product inside the bundle
                      }, 0);
                      return total + bundleTotal;
                    }
                    // If not a bundle, add the item's quantity
                    return total + (item.quantity || 0);
                  }, 0), quantityPrecision)}
              </span>
            </div>)}
        </div>
      )}

      {/* Fulfilled Lines */}
      {!isEstimate && currentTab === '/shopify-fulfilments' && (
        <Fragment>
          {selectedSO?.shopify_fulfillments?.unfulfilled_fulfillments?.length > 0 && (
            <UnFulfilledLines
              unfulfilledFulfillments={selectedSO?.shopify_fulfillments?.unfulfilled_fulfillments}
              handleDrawerState1={(locationId, ffId, productSkuTenantIdMapping, tenantId) => {
                handleDrawerState('CHANGE_LOCATION', locationId, ffId, productSkuTenantIdMapping, tenantId);
              }}
              handleDrawerState2={(locationId, ffId) => {
                handleDrawerState('CREATE_FULFILLMENT', locationId, ffId);
              }}
              soMapping={soMapping}
            />
          )}

          {selectedSO?.shopify_fulfillments?.fulfilled_fulfillments?.length > 0 && (
            <FulfilledLines
              handleDrawerState={(locationId, ffId) => {
                handleDrawerState('RETURN', locationId, ffId);
              }}
              callback={() => {
                const payload = {
                  orgId: user?.tenant_info?.org_id,
                  tenantId: currentTenantId,
                  soId: currentOrderId,
                  orderType: salesOrderType,
                };
                getSOById(payload);
              }}
              fulfilledFulfillments={selectedSO?.shopify_fulfillments?.fulfilled_fulfillments}
              soMapping={soMapping}
            />
          )}
        </Fragment>
      )}
      {
        !isEstimate && currentTab === '/shopify-returns' && (
          <Fragment>
            <ReturnFulfilledLines
              handleDrawerState={(value) => {
                handleDrawerState('REFUND', value);
              }}
            />
          </Fragment>
        )
      }
      {!isEstimate && currentTab === '/shopify-refunds' && (<RefundLines />)}
    </Fragment>
  );
};

export default ViewSOLeftSectionTables;